import React from 'react';
import Image from 'next/image';
import 'swiper/css';
import Head from 'next/head';
import BlogSwiperSection from '../components/PublicRelationsPage/BlogSwiperSection';
import Carousel from '../components/PublicRelationsPage/Carousel';
import LatestPublications from '../components/PublicRelationsPage/LatestPublications';
import ContactMsg from '../components/Contact/ContactMsg';
interface PublicRelationsData {
  title: string;
  meta_description: string;
  meta_title: string;
  banner_title: string;
  canonical: string;
  banner_image: string;
  hero_image: { url: string | null; alternativeText: string | null };
  instagram_posts: Array<{
    display_name: string;
    user_name: string;
    icon: string | null;
    description: string;
    image: string;
    href_link: string;
  }>;
  linked_in_posts: Array<{
    display_name: string;
    user_name: string;
    icon: string | null;
    description: string;
    image: string;
    href_link: string;
  }>;
  selected_blogs: Array<{
    writer: string;
    publicationDate: string;
    page_title: string;
    subheader: string;
    image: { alt_text: string; image: string };
    slug: string;
  }>;
}

interface PublicRelationsPageProps {
  data: PublicRelationsData;
}

const PublicRelationsPage: React.FC<PublicRelationsPageProps> = ({ data }) => {
  return (
    <>
      <Head>
        <title>{data?.meta_title}</title>
        <meta name="og:title" content={data?.meta_title} />
        <meta
          name="og:description"
          content={data?.meta_description}
          key="metadescription"
        />
        <meta name="description" content={data?.meta_description} />
        <link rel="canonical" href={data?.canonical} />
        <meta property="og:image" content="/vertical-seesight-logo.png" />
      </Head>
      <div className="overflow-x-hidden bg-[#e1e1e1] pb-4">
        <div className="relative w-full h-[284px] flex justify-center items-center sm:h-[300px] md:rounded-lg md:w-[calc(100%-70px)] mx-auto xl:w-[calc(100%-12%)] xl:h-[555px] ">
          <Image
            src={data?.banner_image}
            alt="Banner Image"
            width={1920}
            height={1080}
            className="object-cover object-center w-full h-full md:rounded-lg"
          />
          <h1 className="absolute top-[20%] md:top-[10%] left-[10%] md:left-[5%] translate-y-[60%] w-[60%] xl:w-[40%] font-extrabold text-[20px] md:text-[40px] xl:text-[60px] text-white z-1">
            See Sight Tours Public Relations
          </h1>
          <div className="absolute bottom-0 left-[10%] translate-y-[60%] w-[40px] md:left-[5%]  md:w-[70px] xl:w-[157px]">
            <Image
              src={'./red-triangle.svg'}
              alt="red triangle"
              width={200}
              height={210}
              className="object-contain w-full h-full"
            />
          </div>
          <BlogSwiperSection selected_blogs={data?.selected_blogs} />
        </div>

        <LatestPublications />
        <div className="md:mt-[2rem] md:flex md:justify-center opacity-0 md:opacity-100 md:items-center h-[0px] md:h-[179px] ">
          <Image
            src={'/Isolation_Mode.png'}
            alt="See Sight Logo"
            width={200}
            height={210}
            className="object-contain w-[241px] h-[179px]"
          />
        </div>
        <Carousel
          instagram_posts={data?.instagram_posts}
          linked_in_posts={data?.linked_in_posts}
        />

        <div className="mt-[2rem] flex flex-col w-full p-2 mb-2 md:flex-row md:mt-[3rem] md:mb-8 ">
          <div className="w-full md:w-[45%] h-[200px] xl:h-full xl:w-[40%] p-4 md:p-0">
            <Image
              src={'/relations-mask-group.png'}
              alt="contact us image"
              width={1200}
              height={1000}
              className="object-cover w-full h-full translate-x-[-1%] rounded-[2rem] md:translate-x-[2%] md:mt-6 md:h-[340px] lg:h-[470px] xl:h-[540px] xl:w-full xl:translate-x-[-2%] xl:rounded-l-none"
            />
          </div>

          <div className="w-full mt-[1.5rem] ml-0 items-center justify-center md:w-[55%] md:m-0 xl:w-[60%] xl:ml-[-1rem] ">
            <ContactMsg />
          </div>
        </div>
      </div>
    </>
  );
};

// Fetch data from REST API
export async function getStaticProps() {
  const res = await fetch(
    'https://us-central1-tripshepherd-prod.cloudfunctions.net/website/public-relation'
  );
  const data = await res.json();

  return {
    props: {
      data
    }
  };
}

export default PublicRelationsPage;
